import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState } from 'react';
import { WechatContact } from 'src/components/pages/support/WechatContact';
import { CouponBannerForPc } from 'src/components/shared/elements/banners/allVisitorCampaign/CouponBanner/pc';
import { RegisterCampaignBannerForPc } from 'src/components/shared/elements/banners/registerCampaign/RegisterCampaignBannerForPc';
import { Footer } from 'src/components/shared/templates/footer';
import { Header as _Header } from 'src/components/shared/templates/header';
import { BottomMenu } from 'src/components/shared/templates/menu/BottomMenu';
import { SideMenu } from 'src/components/shared/templates/menu/SideMenu';
import { isBrowser } from 'src/libs/wa/utils/env';
import { AuthContext } from 'src/stores/Auth';
import { LOCALE_TYPE } from 'src/types/locale';
import { registerAffiliatesOneQueryParams } from 'src/utils/affiliatesOne';
import { sendUserIdToGA } from 'src/utils/gtagSendUserId';
import { MargeScriptMeasurement } from 'src/utils/margeClient';
import styles from './index.module.scss';

const Header = dynamic(() => Promise.resolve(_Header), {
  ssr: false
});

type LayoutProps = {
  isSideMenuDisabled?: boolean;
  children: React.ReactNode;
  isWebview?: boolean;
  isCouponBannersDisabled?: boolean;
};
export const BaseLayout: React.FC<LayoutProps> = ({
  children,
  isSideMenuDisabled = false,
  isWebview = false,
  isCouponBannersDisabled = false
}) => {
  const { user } = useContext(AuthContext);
  const { locale } = useRouter();
  const [referrer, setReferrer] = useState('');
  useEffect(() => {
    if (isBrowser()) {
      setReferrer(document.referrer);
    }
  }, []);

  useEffect(() => {
    if (locale === LOCALE_TYPE.CN) return;
    if (user) {
      window.dataLayer.push({
        event: 'get_user_id',
        user_id: user.id
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (
      locale !== LOCALE_TYPE.CN && // CN以外のリージョン
      user && // ユーザー情報がある
      referrer.includes('/account/auth/signin?redirect_url') // リファラーに/account/auth/signin?redirect_urlを含む
    ) {
      sendUserIdToGA(user.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, referrer]);

  useEffect(() => {
    MargeScriptMeasurement();
    registerAffiliatesOneQueryParams();
  }, []);
  return (
    <>
      <div className={styles.container}>
        {isWebview ? (
          <div>{children}</div>
        ) : (
          <>
            <Header />
            {!isCouponBannersDisabled && (
              <>{user === undefined ? <RegisterCampaignBannerForPc /> : <CouponBannerForPc />}</>
            )}
            <SideMenu isSideMenuDisabled={isSideMenuDisabled} />
            <div className={styles.contents}>{children}</div>
            <BottomMenu />
            <WechatContact />
            <Footer />
          </>
        )}
      </div>
    </>
  );
};
